// src/services/searchServices.js
import axios from "axios";
const baseUrl = `${process.env.REACT_APP_API_URL}/api/search`;

export const searchAll = async ({ q, page = 1, limit = 20 }) => {
  const { data } = await axios.get(baseUrl, { params: { q, page, limit } });
  return data;
};
